import { type SetState } from '../store';

export type DebugSliceProps = {
    debug: {
        mockedState: string;
        setDailyJackpotsState: (params: string) => void;
        cycle: number;
        incrementDailyJackpotsCycle: () => void;
        resourceMonitorEnabled: boolean;
        toggleResourceMonitor: () => void;
    };
};

export const debugSlice = ({ set }: SetState<DebugSliceProps>): DebugSliceProps => ({
    debug: {
        mockedState: '',
        setDailyJackpotsState: (params) =>
            set(
                (state) => ({
                    debug: {
                        ...state.debug, // TODO: discuss using Immer https://immerjs.github.io/immer/
                        mockedState: params
                    }
                }),
                undefined,
                'setDailyJackpotsState'
            ),
        cycle: 0,
        incrementDailyJackpotsCycle: () =>
            set(
                (state) => ({
                    debug: {
                        ...state.debug,
                        cycle: state.debug.mockedState === 'cycle' ? state.debug.cycle + 1 : 0
                    }
                }),
                undefined,
                'setDailyJackpotsCycle'
            ),
        resourceMonitorEnabled: false,
        toggleResourceMonitor: () =>
            set(
                (state) => ({
                    debug: {
                        ...state.debug,
                        resourceMonitorEnabled: !state.debug.resourceMonitorEnabled
                    }
                }),
                undefined,
                'toggleResourceMonitor'
            )
    }
});
